import React from 'react';

import {
  AgeIcon,
  LungsIcon,
  AutoImmuneIcon,
  CancerIcon,
  DiabetesIcon,
  KidneyLiverIcon,
  HeartIcon,
  BloodTypeIcon,
  BloodBiomarkersIcon,
} from 'on_web/assets/iconsList';
import i18n from '../../i18n';
import { getAppRedirectRoute } from './redirectHelper';

export const getDnaMenuItems = hasFullDna => {
  const iconWidth = '30px';
  let items = [];
  if (hasFullDna) {
    items.push({
      icon: <LungsIcon width={iconWidth} />,
      code: 'respiratory',
      text: i18n.t('reporting.common.dnaCategories.respiratory').toUpperCase(),
    });
    items.push({
      icon: <HeartIcon width={iconWidth} />,
      code: 'cardiac',
      text: i18n.t('reporting.common.dnaCategories.cardiac').toUpperCase(),
    });
    items.push({
      icon: <DiabetesIcon width={iconWidth} />,
      code: 'diabetes',
      text: i18n.t('reporting.common.dnaCategories.diabetes').toUpperCase(),
    });
  }
  items.push({
    icon: <BloodBiomarkersIcon width={iconWidth} />,
    code: 'blood_biomarkers',
    text: 'BLOOD BIOMARKERS',
  });
  items.push({
    icon: <BloodTypeIcon width={iconWidth} />,
    code: 'blood_type',
    text: 'BLOOD TYPE',
  });
  return items;
};

export const getDnaMenuItemIndex = (dnaCategoryCode, hasFullDna) => {
  if (hasFullDna) {
    if (dnaCategoryCode === 'respiratory') {
      return 0;
    } else if (dnaCategoryCode === 'cardiac') {
      return 1;
    } else if (dnaCategoryCode === 'diabetes') {
      return 2;
    } else if (dnaCategoryCode === 'blood_biomarkers') {
      return 3;
    } else if (dnaCategoryCode === 'blood_type') {
      return 4;
    }
  } else {
    if (dnaCategoryCode === 'blood_biomarkers') {
      return 0;
    } else if (dnaCategoryCode === 'blood_type') {
      return 1;
    }
  }
};

export const getDnaGroupCodeByMenuIndex = (dnaCategoryCode, hasFullDna) => {
  if (hasFullDna) {
    if (dnaCategoryCode === 0) return 'respiratory';
    if (dnaCategoryCode === 1) return 'cardiac';
    if (dnaCategoryCode === 2) return 'diabetes';
    if (dnaCategoryCode === 3) return 'blood_biomarkers';
    if (dnaCategoryCode === 4) return 'blood_type';
  } else {
    if (dnaCategoryCode === 0) return 'blood_biomarkers';
    if (dnaCategoryCode === 1) return 'blood_type';
  }
};

export const getCurrentTrait = (dnaTraitCode, traits) => {
  if (traits) {
    return traits.find(t => t.code === dnaTraitCode);
  }
};

export const getNextTrait = (traitCode, allTraits) => {
  let currentIndex = getCurrentTraitIndex(traitCode, allTraits);

  if (hasNext(currentIndex, allTraits)) {
    return allTraits[currentIndex + 1];
  } else {
    return allTraits[currentIndex];
  }
};

export const getPreviousTrait = (traitCode, allTraits) => {
  let currentIndex = getCurrentTraitIndex(traitCode, allTraits);

  if (hasPrevious(currentIndex, allTraits)) {
    return allTraits[currentIndex - 1];
  } else {
    return allTraits[currentIndex];
  }
};

export const getCurrentTraitIndex = (currentTrait, allTraits) => {
  return allTraits
    .map(function(e) {
      return e.code;
    })
    .indexOf(currentTrait);
};

export const hasPreviousGroup = currentGroupCode => {
  let currentIndex = getCurrentTraitIndex(
    currentGroupCode,
    getComorbiditiesMenuItems()
  );
  return hasPrevious(currentIndex);
};

export const hasNextGroup = (currentGroupCode, array) => {
  let currentIndex = getCurrentTraitIndex(
    currentGroupCode,
    getComorbiditiesMenuItems()
  );

  return hasNext(currentIndex, array);
};

export const getNextGroup = currentComorbidityGroupCodeIx => {
  let nextGroup =
    getComorbiditiesMenuItems() &&
    getComorbiditiesMenuItems()[currentComorbidityGroupCodeIx + 1];

  return nextGroup;
};

export const getPreviousGroup = currentComorbidityGroupCodeIx => {
  let previousGroup =
    getComorbiditiesMenuItems() &&
    getComorbiditiesMenuItems()[currentComorbidityGroupCodeIx - 1];

  return previousGroup;
};

export const hasPreviousGroupDna = (currentGroupCode, hasFullDna) => {
  let currentIndex = getCurrentTraitIndex(
    currentGroupCode,
    getDnaMenuItems(hasFullDna)
  );
  return hasPrevious(currentIndex);
};

export const hasNextGroupDna = (currentGroupCode, array, hasFullDna) => {
  let currentIndex = getCurrentTraitIndex(
    currentGroupCode,
    getDnaMenuItems(hasFullDna)
  );

  return hasNext(currentIndex, array);
};

export const getNextGroupDna = (currentTraitGroupCodeIx, hasFullDna) => {
  let nextGroup =
    getDnaMenuItems(hasFullDna) &&
    getDnaMenuItems(hasFullDna)[currentTraitGroupCodeIx + 1];

  return nextGroup;
};

export const getPreviousGroupDna = (currentTraitGroupCodeIx, hasFullDna) => {
  let previousGroupDna =
    getDnaMenuItems(hasFullDna) &&
    getDnaMenuItems(hasFullDna)[currentTraitGroupCodeIx - 1];

  return previousGroupDna;
};

export const hasPrevious = currentIndex => {
  if (currentIndex <= 0) {
    return false;
  } else {
    return true;
  }
};

export const hasNext = (currentIndex, array) => {
  if (currentIndex >= array.length - 1) {
    return false;
  } else {
    return true;
  }
};

// TODO (bsevo): this has to be updated but from Zeplin it isn't clear what are the menu items for comorbidities
export const getComorbiditiesMenuItems = () => {
  const iconWidth = '30px';

  return [
    {
      icon: <AutoImmuneIcon width={iconWidth} />,
      code: 'autoimmune',
    },
    {
      icon: <HeartIcon width={iconWidth} />,
      code: 'cardiac',
    },
    {
      icon: <LungsIcon width={iconWidth} />,
      code: 'respiratory',
    },
    {
      icon: <DiabetesIcon width={iconWidth} />,
      code: 'bmi_diabetes',
    },
    {
      icon: <KidneyLiverIcon width={iconWidth} />,
      code: 'kidney',
    },
    {
      icon: <CancerIcon width={iconWidth} />,
      code: 'cancer',
    },
    {
      icon: <AgeIcon width={iconWidth} />,
      code: 'age',
    },
  ];
};

export const getComorbiditiesMenuItemIndex = comorbidityGroupCode => {
  if (comorbidityGroupCode === 'autoimmune') {
    return 0;
  } else if (comorbidityGroupCode === 'cardiac') {
    return 1;
  } else if (comorbidityGroupCode === 'respiratory') {
    return 2;
  } else if (comorbidityGroupCode === 'bmi_diabetes') {
    return 3;
  } else if (comorbidityGroupCode === 'kidney') {
    return 4;
  } else if (comorbidityGroupCode === 'cancer') {
    return 5;
  } else if (comorbidityGroupCode === 'age') {
    return 6;
  }
};

export const getComorbidityGroupCodeByMenuIndex = comorbidityGroupCode => {
  if (comorbidityGroupCode === 0) return 'autoimmune';
  if (comorbidityGroupCode === 1) return 'cardiac';
  if (comorbidityGroupCode === 2) return 'respiratory';
  if (comorbidityGroupCode === 3) return 'bmi_diabetes';
  if (comorbidityGroupCode === 4) return 'kidney';
  if (comorbidityGroupCode === 5) return 'cancer';
  if (comorbidityGroupCode === 6) return 'age';
};

export const getRiskForComorbidity = (comorbidityCode, risks) => {
  const riskValue = risks[comorbidityCode].level
    ? risks[comorbidityCode].level
    : 0;
  const riskLevel = riskValue < 30 ? 0 : riskValue > 50 ? 2 : 1;

  return {
    value: riskValue,
    level: riskLevel === 0 ? 'low' : riskLevel === 1 ? 'medium' : 'high',
    levelLabel: risks[comorbidityCode].level_label,
    code: comorbidityCode,
  };
};

export const mapRoutesToMenuItems = userMetaData => {
  const menuTextValues = i18n.t('common.menu.extraItems', {
    returnObjects: true,
  });

  let menuItems = [];
  Object.keys(menuTextValues).forEach(element => {
    let route = getAppRedirectRoute(element, userMetaData);
    menuItems.push({ value: menuTextValues[element], route });
  });

  return menuItems;
};
